"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.66",
    y: "15.27",
    width: "5.04",
    height: "4.95",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1.62",
    y: "1.58",
    width: "5.04",
    height: "4.95",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "15.55",
    y: "1.58",
    width: "5.04",
    height: "4.95",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.27,0H0V8.11H8.27ZM6.66,6.53h-5V1.58h5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.2,0H14V8.11H22.2ZM20.59,6.53h-5V1.58h5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,21.8H8.27V13.69H0Zm1.65-6.53h5v4.95h-5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.15",
    width: "1.93",
    height: "8.11",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.06",
    y: "10.91",
    width: "15.14",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.01",
    y: "9.09",
    width: "3.91",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.63,15.46v1.83H12.8a5.93,5.93,0,0,1,.82-1.83Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.77,13.7A5.15,5.15,0,1,0,24,18.85,5.19,5.19,0,0,0,18.77,13.7Zm2.9,3.22L18.3,21.51a.68.68,0,0,1-1,.08l-1.38-1.38a.67.67,0,0,1,.53-1.13h0a.66.66,0,0,1,.44.2l.81.82,2.9-4a.68.68,0,0,1,.95-.15.66.66,0,0,1,.27.43h0A.62.62,0,0,1,21.67,16.92Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;